import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import RoundedBox from '@sharedCR/common/RoundedBox';
import PopTipCDS from '@sharedCR/coreDesignSystem/PopTipCDS';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { POST_CLOSING_DUE_DATE_TOOLTIP } from './FinalDocumentsSection.constants';
import {
  fieldLabelRowStyles,
  getFieldColumnStyles,
  getFieldValueStyles,
  sectionGridStyles,
  tooltipIconStyles,
} from './FinalDocumentsSection.styles';

const FinalDocumentsSection = ({ isLoading, config }) => (
  <RoundedBox padding={16}>
    <Box sx={sectionGridStyles}>
      {config.map(({ id, name, value, isReadOnly, withTooltip, isFullWidth }) => (
        <Box key={id} sx={getFieldColumnStyles(isFullWidth)}>
          {isLoading ? (
            <Skeleton height={50} variant="text" />
          ) : (
            <>
              <Box sx={fieldLabelRowStyles}>
                <Typography color="text.secondary" variant="regular14">
                  {name}
                </Typography>
                {withTooltip && (
                  <PopTipCDS arrow title={POST_CLOSING_DUE_DATE_TOOLTIP}>
                    <span aria-label="More info" style={tooltipIconStyles}>
                      &#9432;
                    </span>
                  </PopTipCDS>
                )}
              </Box>
              <Typography
                color={isReadOnly ? 'text.secondary' : undefined}
                sx={getFieldValueStyles(isFullWidth)}
                variant="bold16"
              >
                {_.isNil(value) ? '-' : value}
              </Typography>
            </>
          )}
        </Box>
      ))}
    </Box>
  </RoundedBox>
);

FinalDocumentsSection.propTypes = {
  ...WithLoadingPropTypes,
  config: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.string,
      isReadOnly: PropTypes.bool,
      withTooltip: PropTypes.bool,
      isFullWidth: PropTypes.bool,
    }),
  ).isRequired,
};

export default FinalDocumentsSection;
